var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageLayout',{attrs:{"title":_vm.$t('profile.billing_title')}},[_c('ProfileBilling')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }